import { render } from "./App.vue?vue&type=template&id=1411b816"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1411b816&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\sapiping\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QTable,QTab});
